import {
  buildProviders,
  makeStandardFetcher,
  targets,
} from "@movie-web/providers";

import { isExtensionActiveCached } from "@/backend/extension/messaging";
import {
  makeExtensionFetcher,
  makeLoadBalancedSimpleProxyFetcher,
  setupM3U8Proxy,
} from "@/backend/providers/fetchers";

// Initialize M3U8 proxy on module load
setupM3U8Proxy();

export function getProviders() {
  if (isExtensionActiveCached()) {
    return buildProviders()
      .setTarget(targets.BROWSER_EXTENSION)
      .setFetcher(makeStandardFetcher(fetch))
      .setProxiedFetcher(makeExtensionFetcher())
      .enableConsistentIpForRequests()
      .addBuiltinProviders()
      .build();
  }

  setupM3U8Proxy();

  return buildProviders()
    .setTarget(targets.BROWSER)
    .setFetcher(makeStandardFetcher(fetch))
    .setProxiedFetcher(makeLoadBalancedSimpleProxyFetcher())
    .addBuiltinProviders()
    .build();
}

export function getAllProviders() {
  return buildProviders()
    .setTarget(targets.BROWSER_EXTENSION)
    .setFetcher(makeStandardFetcher(fetch))
    .enableConsistentIpForRequests()
    .addBuiltinProviders()
    .build();
}
